import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/css/main.css';

import { createApp } from 'vue';
//import { createMetaManager, plugin as metaPlugin } from 'vue-meta';
import App from './App.vue';

const app = createApp(App);
// const metaManager = createMetaManager();
// app.use(metaManager);
// app.use(metaPlugin);
app.mount('#app');

// import { createPinia } from 'pinia'
// app.use(createPinia())
//import router from './router'
//app.use(router)
